<template>
  <component v-bind="containerTag.props" :is="containerTag.name">
    <slot name="before-name" />
    <component
      v-bind="{ ...parrierTag.props, ...(customBind.name || {}) }"
      :is="parrierTag.name"
    >
      <v-text-field
        v-bind="{ ...(customBind.nameInput || {}), ...textFieldProps }"
        v-model="input.name"
        placeholder="Receiver Name"
      />
    </component>
    <slot v-if="!put" name="before-number" />
    <component
      v-if="!put"
      v-bind="{ ...parrierTag.props, ...(customBind.app || {}) }"
      :is="parrierTag.name"
    >
      <v-text-field
        v-model="input.receiver_number"
        v-bind="{ ...(customBind.phoneInput || {}), ...textFieldProps }"
        placeholder="Phone Number"
      />
    </component>
    <slot v-if="!put" name="before-params" />
    <!-- <div v-if = "!put" v-for="(parameter, p) in input.parameters" :key="p">
    <label>{{ parameter.attribute }}</label>
    <component
      v-if = "!put"
      v-bind = "{...parrierTag.props, ...customBind.params || {} }"
      :is = "parrierTag.name">
      <v-text-field
        v-model = "parameter.value"
        v-bind = "{ ...customBind.paramsInput || {} , ...textFieldProps}"
        :placeholder = "parameter.attribute" />
    </component> -->
    <div
      v-if="!put && parameters && input.parameters && input.parameters.length"
    >
      <label class="black--text pb-0 mb-0" style="font-size: 16px"
        >Parameters</label
      >

      <div v-for="(param, p) in input.parameters" :key="p">
        <label>{{ param.attribute | resolveParamName }}</label>
        <v-text-field
          placeholder="Enter Here"
          v-model="param.value"
          outline
          hide-details
          dense
        />
      </div>
    </div>

    <slot v-for="(slot, s) in new Array(slots)" :name="`tail-slot-${s + 1}`" />
  </component>
</template>

<script>
export default {
  name: "AddReceiver",
  filters: {
    resolveParamName(name) {
      return name.split(/\{|\}/).join("").split("_").join(" ");
    },
  },
  props: {
    containerTag: {
      type: Object,
      default() {
        return {
          name: "div",
          props: {
            class: "",
          },
        };
      },
    },
    parrierTag: {
      type: Object,
      default() {
        return {
          name: "div",
          props: {
            class: "",
          },
        };
      },
    },
    textFieldProps: {
      type: Object,
      default() {
        return {
          outline: true,
        };
      },
    },
    slots: {
      type: Number,
      default: 2,
    },
    customBind: {
      type: Object,
      default() {
        return {};
      },
    },
    put: {
      type: Object,
      default: null,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isValid: false,
      apps: [],
      parameters: null,
      input: {
        name: "",
        receiver_number: "",
        parameters: [],
      },
    };
  },
  // computed: {
  //   parameters() {
  //     return this.$store.state.campaigns.selectedCampaign ? this.$store.state.campaigns.selectedCampaign.parameters : []
  //   }
  // },
  watch: {
    put(val) {
      if (val) this.input = val;
      else this.resetForm();
    },
    parameters: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.input.parameters = this.$_.cloneDeep(val);
        }
      },
    },
    dialog(val) {
      if (val) {
        this.getTemplateMessage();
      }
    },
  },
  mounted() {
    // this.getTemplateMessage();
    this.$root.$on("add-receiver-inits", (payload) => {
      this.input.channel = "whatsapp";
      this.input = payload;
    });
  },
  methods: {
    async getTemplateMessage() {
      try {
        const templateMessage =
          this.$store.state.campaigns.selectedCampaign &&
          this.$store.state.campaigns.selectedCampaign.message
            ? this.$store.state.campaigns.selectedCampaign.message
                .template_msg_id
            : null;
        if (!templateMessage) {
          return;
        }
        this.emitLoading(true);
        const response = await this.$http_session_manager(
          `/template-message/${templateMessage}`
        );

        this.input.parameters = this.$_.cloneDeep(response.data.parameters);
        this.parameters = this.$_.cloneDeep(response.data.parameters);
        // this.parameters = res.data.parameters
        this.emitLoading(false);
      } catch (error) {
        this.emitLoading(false);
        throw error;
      }
    },
    async submit() {
      try {
        if (
          this.input.name.length &&
          this.input.receiver_number.length &&
          !this.input.parameters.filter((i) => !i.value.length).length
        ) {
          this.emitLoading(true);
          const payload = this.put
            ? { ...this.input, id: this.put._id }
            : this.input;

          await this.$store.dispatch(
            `receivers/${this.put ? "update" : "add"}`,
            payload
          );

          this.resetForm();
          this.emitLoading(false);
          this.$emit("success");
        }
      } catch (e) {
        this.emitLoading(false);
        throw e;
      }
    },
    async resetForm() {
      this.input = {
        name: "",
        receiver_number: "",
        parameters: this.$_.cloneDeep(this.parameters),
      };
      return true;
    },
    emitLoading(status = true) {
      this.$emit("loading", status);
    },
  },
};
</script>

<style lang="css" scoped>
.platform-wrapper {
  border-radius: 50%;
  padding: 5px;
  height: 30px;
  width: 30px;

  font-size: 20px;
}
</style>
